module.exports = __webpack_public_path__ + "static/media/94.6dc1c86e.jpg";